var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcFiles = function SvgIcFiles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 32,
    viewBox: "0 0 38 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 28,
    x: 1,
    y: 1,
    fill: "#F9F9FB",
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5B718D",
    fillRule: "nonzero",
    d: "M19,0 C20.6568542,0 22,1.34314575 22,3 L22,27 C22,28.6568542 20.6568542,30 19,30 L3,30 C1.34314575,30 0,28.6568542 0,27 L0,3 C0,1.34314575 1.34314575,0 3,0 L19,0 Z M19,2 L3,2 C2.48716416,2 2.06449284,2.38604019 2.00672773,2.88337887 L2,3 L2,27 C2,27.5128358 2.38604019,27.9355072 2.88337887,27.9932723 L3,28 L19,28 C19.5128358,28 19.9355072,27.6139598 19.9932723,27.1166211 L20,27 L20,3 C20,2.48716416 19.6139598,2.06449284 19.1166211,2.00672773 L19,2 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 2,
    x: 4,
    y: 5,
    fill: "#AAB5C4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 2,
    x: 4,
    y: 8,
    fill: "#AAB5C4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 2,
    x: 4,
    y: 18,
    fill: "#AAB5C4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 2,
    x: 4,
    y: 21,
    fill: "#AAB5C4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 2,
    x: 4,
    y: 24,
    fill: "#AAB5C4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 18,
    x: 15,
    y: 13,
    fill: "#F9F9FB",
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5B718D",
    fillRule: "nonzero",
    d: "M35,12 C36.6568542,12 38,13.3431458 38,15 L38,29 C38,30.6568542 36.6568542,32 35,32 L17,32 C15.3431458,32 14,30.6568542 14,29 L14,15 C14,13.3431458 15.3431458,12 17,12 L35,12 Z M35,14 L17,14 C16.4871642,14 16.0644928,14.3860402 16.0067277,14.8833789 L16,15 L16,29 C16,29.5128358 16.3860402,29.9355072 16.8833789,29.9932723 L17,30 L35,30 C35.5128358,30 35.9355072,29.6139598 35.9932723,29.1166211 L36,29 L36,15 C36,14.4871642 35.6139598,14.0644928 35.1166211,14.0067277 L35,14 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#AAB5C4",
    points: "18 28 34 28 34 16 30 20 28 18"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 18,
    r: 2,
    fill: "#AAB5C4"
  }))));
};
export default SvgIcFiles;